import React from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from '../../../../utils/validators';
import { WeezHeader, Button, ToastContext, SplitContainer } from '@weezevent/nacre';
import Widget from '../../../../models/widget';
import { Loader } from 'semantic-ui-react';
import WidgetPreviewButton from '../../components/widget-preview-button';
import Translations from '../../components/translations/translations';
import { WidgetPreview } from '../../components/pages/new-widget';
import Style from './settings.module.css';

export default function PersonalSpaceTranslations({ organization, personalSpaceId }) {
    const { t } = useTranslation();
    const toast = React.useContext(ToastContext);
    const [submitting, setSubmitting] = React.useState(false);

    const [form, setForm, setFormObject] = useForm({
        id: null,
        default_language: 'en-gb',
        languages: [],
        translations: {}
    });

    const [widget, loadingWidget] = Widget.useApiModel(
        {
            organizationId: organization.pk,
            id: personalSpaceId,
            query: {
                usage__in: ['personal_space', 'moderation']
            },
            onSuccess: _widget => {
                setFormObject({
                    id: _widget.id,
                    default_language: _widget.default_language,
                    languages: _widget.languages,
                    translations: _widget.translations
                });
            }
        },
        [personalSpaceId, organization]
    );

    const handleSubmit = React.useCallback(() => {
        setSubmitting(true);
        let new_widget = new Widget(form);
        new_widget
            .save({ organizationId: organization.id })
            .then(() => {
                toast.success(t('ticket.personal_spaces.settings.toast-success'));
            })
            .catch(e => {
                console.error(e);
                toast.error(t('ticket.personal_spaces.settings.toast-error'));
            })
            .finally(() => {
                setSubmitting(false);
            });
    }, [organization, form, toast, t]);

    if (loadingWidget) {
        return <Loader active />;
    }

    return (
        <div className={Style['personal-space-container']}>
            <WeezHeader
                rightComponent={[
                    <WidgetPreviewButton key="preview" widget={widget} />,
                    <Button primary key="save" label={t('ticket.common.action.save')} onClick={handleSubmit} disabled={submitting} />
                ]}
                title={t('ticket.personal_spaces.translations.title')}
            >
                {t('ticket.personal_spaces.translations.subtitle')}
            </WeezHeader>
            <SplitContainer size="maxi" additional={<WidgetPreview widget={widget} />}>
                <Translations
                    languages={form.languages}
                    default_language={form.default_language}
                    onChangeForm={setForm}
                    translations={form.translations}
                    wording_structure={widget.wording_structure}
                    form={form}
                />
            </SplitContainer>
        </div>
    );
}
